import React, { useState, useEffect, useCallback } from 'react'
import { cartMobx } from 'restaurant'
import { Price, ProductImage, Stepper, Tags, RequiredBadge } from 'components'
import productStyleController from '@ctrls/productStyleController'
import CashierController from '@ctrls/cashierController'

import MonthSaleInfo from '@pages/menu/components/ProductItem/MonthSaleInfo'
import './index.scss'

type TProductItem = 'waterfall' | 'recommend' | 'classic' | 'list';
interface IProps {
  type?: TProductItem;
  product: IViewProduct;
  count?: number;
  lazy?: boolean;
  backgroundMode?: 'light' | 'dark';
  imgLoaded?: boolean;
  decorate?: TMealCommonDecorates;
}

const WaterfallProductItem: React.FC<IProps> = props => {
  const { type = 'waterfall', product, count, lazy = false, decorate, imgLoaded = false } = props
  let { no, name, price, actualPrice, memberPrice, saleCnt, offPrice, isMemberDiscount, isCanTogo } = product || {}

  const [defaultImg, setDefault] = useState<string>('')
  useEffect(() => {
    const imgArr = JSON.parse(product.pics || '[]')
    const defaultItem = imgArr.filter(item => item.default !== 0)
    const defaultImgUrl: string = defaultItem.length ? (defaultItem[0].type === 'video' ? defaultItem[0].videoImageUrl : product.pic) : product.pic
    setDefault(defaultImgUrl)
  }, [product])

  const ecolor = Config.colorImages[product.categories?.[0]?.charCodeAt(0) % 4]
  const soldout = saleCnt === 0
  // 是否展示加购按钮
  const isShowAddBtn = !!Config.buyTogetherId || !!decorate?.showAddButton
  const [productStyle] = useState(() => {
    if (type === 'waterfall') {
      const imgWidth = window.innerWidth / 2 - productStyleController.getWidthPer(3)
      const imgHeight = imgWidth * Number(product.picHeight || 360) / Number(product.picWidth || 360)
      return {
        width: imgWidth,
        height: imgHeight
      }
    } else if (type === 'recommend') {
      const imgWidth = window.innerWidth - 32
      const imgHeight = imgWidth * Number(product.picHeight || 360) / Number(product.picWidth || 360)
      return {
        width: imgWidth,
        height: imgHeight
      }
    }
  })

  const handleChangeCnt = useCallback((isAdd: boolean, event: React.MouseEvent) => {
    event.stopPropagation()
    CashierController.handleProductToCart({
      type: isAdd ? 'add' : 'minus',
      product
    })
  }, [count])
  return (
    <>
      <div className='product-image-wrap'>
        {
          !defaultImg
            ? (
              <div
                className='watercolor' style={{
                  backgroundColor: ecolor
                }}
              >
              </div>
            ) : (
              <ProductImage
                color={!defaultImg ? product.no : ''}
                imgSrc={(imgLoaded || !lazy) ? defaultImg : ''}
                width={productStyle.width}
                height={productStyle.height}
                className={type === 'waterfall' ? 'waterfall-img' : ''}
              />
            )
        }
        {product.type === 'product' && product.isRequired && <RequiredBadge />}
      </div>
      <div className='product-info'>
        <div className='product-name' style={{ fontSize: `${decorate?.fontSetting?.name?.fontSize || 16}px`, fontWeight: decorate?.fontSetting?.name?.fontWeight ? 700 : 500 }}>{name}</div>
        {
          !!product.intro && <p className='product-intro' dangerouslySetInnerHTML={{ __html: product.intro.replace(/<style[\S\s]*<\/style>/g, '').replace(/<img[^>]*>/g, '') }}></p>
        }
        <Tags datas={[...(product.tags || []), ...(product.allergys || [])]} salesCnt={product.salesCnt} disableTogo={cartMobx.info.eatType !== 'dinein' && !product.isCanTogo} disableSingleSale={!product.isSingleSale} />
        <MonthSaleInfo showHot={decorate?.showHot} showMonthSales={decorate?.showMonthSales} statSaleCnt={product.statSaleCnt} statAvatar={product.statAvatar} />
        <div className='product-actions'>
          <Price
            decorate={decorate}
            className='product-price'
            price={price}
            actualPrice={actualPrice}
            hideMarketPrice={!!count}
            soldOut={soldout}
            offPrice={offPrice}
            memberPrice={memberPrice}
            isMemberDiscount={isMemberDiscount}
          />
          {!soldout && isShowAddBtn && <Stepper cnt={count} min={cartMobx.getMenuRequiredProductMinCnt(product.no, count || 0)} onChange={handleChangeCnt} hideMinus={count === 0} disabled={cartMobx.info.eatType !== 'dinein' && !isCanTogo} />}
          {
            soldout && <span className='sold-out-msg'>{i18n.t('common.soldout')}</span>
          }
        </div>
      </div>
      {
        !!count && !isShowAddBtn && <div className='product-cnt'>{count}</div>
      }
    </>
  )
}

export default WaterfallProductItem
